import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StoreService } from 'src/app/shared/services/store.service';
import { DirectionService } from '../../../shared/services/direction.service';

declare let $;

import 'owl.carousel';

@Component({
    selector: 'app-block-slideshow',
    templateUrl: './block-slideshow.component.html',
    styleUrls: ['./block-slideshow.component.scss']
})
export class BlockSlideshowComponent implements OnInit, AfterViewInit {
    @Input() withDepartments = false;

    options = {
        nav: false,
        dots: true,
        loop: true,
        autoHeight: true,
        items: 1,
        rtl: this.direction.isRTL(),
        autoplay: true,
    };

    slides;

    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService,
        private store: StoreService
    ) {
        this.options['autoplayTimeout'] = this.store.carousel_time * 1000;
        this.slides = this.store.slides;
    }
    ngAfterViewInit(): void {
        let options = this.options;
        $(document).ready(function(){
            let owl = $('.block-slideshow__body .owl-carousel').owlCarousel(options);

            var timer = setInterval(function() {
                if(owl.height() > 1) clearInterval(timer);
                owl.trigger('refresh.owl.carousel', [100]);
            }, 300);
        });

    }

    ngOnInit(): void {

    }

    width() {
        return window.innerWidth;
    }
}
